import React, { useEffect } from "react";
import "../Css/Savani.css";
import AboutStart from "../Component/About/AboutStart";
import AboutSection from "../Component/About/AboutSection";
import AboutSection2 from "../Component/About/AboutSection2";
import AboutSection3 from "../Component/About/AboutSection3";
import AboutSection4 from "../Component/About/AboutSection4";


const About = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <div>
      <AboutStart />
      <AboutSection />
      <AboutSection2 />
      <AboutSection3 />
      <AboutSection4 />
    </div>
  );
};

export default About;
